import React, { useState, useEffect } from 'react';
import { collection, addDoc, getDocs, deleteDoc, doc } from "firebase/firestore";
import { db } from './../../firebase/firebaseConfig';
import Layout from './Layout';
import PageTitle from '../includes/PageTitle';
import './../css/Login.css'

const AddCategoryForm = () => {
  const [categoryName, setCategoryName] = useState('');
  const [categories, setCategories] = useState([]);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchCategories = async () => {
      const categoriesCollection = collection(db, "Categories");
      const categorySnapshot = await getDocs(categoriesCollection);
      const categoryList = categorySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      setCategories(categoryList);
    };

    fetchCategories();
  }, []);

  const validateCategoryName = (name) => {
    // Basic validation: Check if the name is not empty and does not contain special characters
    const trimmedName = name.trim();
    if (trimmedName === '') {
      return 'Category name cannot be empty.';
    }
    if (/[^a-zA-Z0-9\s]/.test(trimmedName)) {
      return 'Category name contains invalid characters.';
    }
    return '';
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Validate category name
    const validationError = validateCategoryName(categoryName);
    if (validationError) {
      setError(validationError);
      return;
    }

    try {
      const newCategory = await addDoc(collection(db, "Categories"), {
        name: categoryName
      });
      alert(`Category "${categoryName}" added successfully!`);
      setCategories([...categories, { id: newCategory.id, name: categoryName }]);
      setCategoryName('');
      setError(''); // Clear any previous errors
    } catch (e) {
      console.error("Error adding category: ", e);
      alert('Error adding category.');
    }
  };

  const handleDelete = async (id) => {
    try {
      await deleteDoc(doc(db, "Categories", id));
      setCategories(categories.filter(category => category.id !== id));
      alert('Category deleted successfully!');
    } catch (e) {
      console.error("Error deleting category: ", e);
      alert('Error deleting category.');
    }
  };

  return (
    <>
      <PageTitle title="Add Category - ALMOSTINVISIBLE" />
      <Layout>
        <h1 className="unbounded">Category</h1>
        <hr />
        <p className='unbounded fw-bold black-bordered-bottom'>Add Category</p>
        <form onSubmit={handleSubmit}>
          <div>
                <div className="flex-column">
                    <label className='nunito-2'>Category Name*</label>
                </div>
                <div className="inputForm">
                    <input
                        type="text"
                        value={categoryName}
                        onChange={(e) => setCategoryName(e.target.value)}
                        required
                        className="input"
                        style={{fontWeight: "bold"}}
                        placeholder='Enter the name of the category you want to add'
                    />
                </div>
                {error && <p className='error-message'>{error}</p>}
          </div>
          <br />
          <button type="submit" className='black-button'>Add Category</button>
        </form>

        <hr />
        <div className='container'>
            <p className='unbounded fw-bold black-bordered-bottom'>List Of Categories</p>
          <ul>
          {categories.map((category, index) => (
              <li key={category.id} className='d-flex justify-content-between my-2'>
                <span>{index + 1}. {category.name}</span>
                <button className='red-button' onClick={() => handleDelete(category.id)}>
                    <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 16 16" height="1.2em" width="1.2em" xmlns="http://www.w3.org/2000/svg"><path d="M5.5 5.5A.5.5 0 016 6v6a.5.5 0 01-1 0V6a.5.5 0 01.5-.5zm2.5 0a.5.5 0 01.5.5v6a.5.5 0 01-1 0V6a.5.5 0 01.5-.5zm3 .5a.5.5 0 00-1 0v6a.5.5 0 001 0V6z"></path><path fill-rule="evenodd" d="M14.5 3a1 1 0 01-1 1H13v9a2 2 0 01-2 2H5a2 2 0 01-2-2V4h-.5a1 1 0 01-1-1V2a1 1 0 011-1H6a1 1 0 011-1h2a1 1 0 011 1h3.5a1 1 0 011 1v1zM4.118 4L4 4.059V13a1 1 0 001 1h6a1 1 0 001-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z" clip-rule="evenodd"></path></svg>    
                    
                    &nbsp; Delete
                </button>
              </li>
            ))}
          </ul>
        </div>
      </Layout>
    </>
  );
};

export default AddCategoryForm;
